/**
 * Gujarati for the `booking` namespace (BP-19.T2).
 *
 * **Machine draft, not reviewed** — see `strings.hi.ts` for why this namespace is
 * translated in full.
 */

export const bookingStringsGu = {
  landing: {
    title: 'એપોઇન્ટમેન્ટ બુક કરો',
    lead: 'તમારી સેવાઓ પસંદ કરો, સમય નક્કી કરો — ખુરશી તમારા માટે રાખી મૂકીશું.',
    start: 'હમણાં બુક કરો',
    mine: 'મારી બુકિંગ',
  },
  steps: {
    services: 'સેવાઓ',
    technician: 'ટેકનિશિયન',
    slot: 'સમય',
    verify: 'તમારો નંબર',
    confirm: 'ખાતરી',
  },
  services: {
    title: 'તમારે શું કરાવવું છે?',
    none: 'અત્યારે ઑનલાઇન કોઈ સેવા બુક થઈ શકતી નથી',
    addons: 'વધારાની સેવાઓ',
    duration: '{{minutes}} મિનિટ',
    running: '{{minutes}} મિનિટ · ₹{{amount}}',
    next: 'ટેકનિશિયન પસંદ કરો',
    pickOne: 'ઓછામાં ઓછી એક સેવા પસંદ કરો',
  },
  technician: {
    title: 'કોની પાસે કરાવવું છે?',
    any: 'જે કોઈ ઉપલબ્ધ હોય',
    anyHint: 'સૌથી પહેલાં ખાલી થતી ખુરશી',
    next: 'સમય પસંદ કરો',
    none: 'અત્યારે કોઈ ઑનલાઇન બુકિંગ લેતું નથી',
  },
  slot: {
    title: 'કયો સમય ફાવશે?',
    none: 'તે દિવસે કશું ખાલી નથી',
    suggestion: 'પછીનો ખાલી દિવસ {{date}} છે',
    next: 'આગળ વધો',
  },
  verify: {
    title: 'તમારો મોબાઇલ નંબર',
    phone: 'મોબાઇલ નંબર',
    phoneHint: 'અમે WhatsApp પર એક-વખતનો કોડ મોકલીએ છીએ.',
    phoneInvalid: 'આ ભારતીય મોબાઇલ નંબર લાગતો નથી.',
    send: 'કોડ મોકલો',
    resend: 'ફરી મોકલો',
    resendIn: 'તમે {{seconds}} સેકન્ડ પછી ફરી માંગી શકો છો',
    code: 'એક-વખતનો કોડ',
    verify: 'ચકાસો',
    consent: 'મને WhatsApp પર એપોઇન્ટમેન્ટની યાદ અપાવો',
    consentHint: 'તમે આ ગમે ત્યારે બંધ કરી શકો છો.',
    notice: 'અમે તમારી માહિતીનું શું કરીએ છીએ',
    invalid: 'આ કોડ મળ્યો નહીં. ફરી પ્રયાસ કરો.',
    exhausted: 'ઘણી વાર પ્રયાસ થયો. નવો કોડ માંગો.',
  },
  confirm: {
    title: 'તમારી બુકિંગની ખાતરી કરો',
    summary: 'તમારું એપોઇન્ટમેન્ટ',
    total: 'કુલ',
    book: 'ખાતરી કરો',
    taken: 'આ સમય હમણાં જ જતો રહ્યો. કૃપા કરીને બીજો પસંદ કરો.',
    policy:
      'શરૂ થવાના {{hours}} કલાક પહેલાં સુધી તમે આ બુકિંગ ઑનલાઇન બદલી કે રદ કરી શકો છો. પછી સલૂનને ફોન કરો.',
  },
  detail: {
    title: 'બુકિંગ {{ref}}',
    when: 'ક્યારે',
    status: 'સ્થિતિ',
    reschedule: 'સમય બદલો',
    cancel: 'આ બુકિંગ રદ કરો',
    cancelTitle: 'બુકિંગ {{ref}} રદ કરવી છે?',
    cancelReason: 'કારણ જણાવો (મરજિયાત)',
    cancelConfirm: 'હા, રદ કરો',
    cancelKeep: 'રહેવા દો',
    locked: 'આ બુકિંગ હવે ઑનલાઇન બદલી શકાતી નથી. કૃપા કરીને સલૂનને ફોન કરો.',
    pickNew: 'નવો સમય પસંદ કરો',
    keep: 'હાલનો સમય રાખો',
    moved: 'તમારી બુકિંગનો સમય બદલાયો છે.',
    cancelled: 'તમારી બુકિંગ રદ કરવામાં આવી છે.',
  },
  waitlist: {
    offer: 'એ સમય લેવાઈ ગયો છે. ખાલી થાય તો તમને જણાવીએ?',
    join: 'ખાલી થાય તો જણાવો',
    joined: 'ખાલી થતાં જ અમે તમને સંદેશ મોકલીશું.',
    failed: 'અત્યારે તમને ઉમેરી શક્યા નથી. કૃપા કરી ફરી પ્રયાસ કરો.',
  },
  mine: {
    title: 'મારી બુકિંગ',
    none: 'તમારી કોઈ આવનારી બુકિંગ નથી',
    open: 'ખોલો',
  },
} as const;
